import * as yup from 'yup';
export const priceFormSchema = yup.object({
  rate: yup.number(),
  pricePerPack: yup.number(),
  creditPrice: yup.number(),
  prepaidPrice: yup.number(),
  prdMrp: yup.number(),
  lastRefreshDate: yup.string(),
  validityStartDate: yup.string(),
  validityEndDate: yup.string(),
});

export type TPriceFormData = yup.InferType<
  typeof priceFormSchema
>;

export const inventoryFormSchema = yup.object({
  closingStock: yup.number(),
  blockedStock: yup.number(),
  liveStock: yup.number(),
  lastRefreshDate: yup.date(),
});
export type TInventoryFormData = yup.InferType<
  typeof inventoryFormSchema
>;

export const commissionFormSchema = yup.object({
  commission: yup.number(),
  gst: yup.number(),
  tds: yup.number(),
});
export type TCommissionFormData = yup.InferType<
  typeof commissionFormSchema
>;

export const productForm = yup.object({
  matnr: yup.string(),
  productName: yup.string(),
  category: yup.string(),
  steuc: yup.string(),
  brand: yup.string(),
  parentBrand: yup.string(),

  pack: yup.string(),
  baseUOM: yup.string(),
  sgst: yup.number(),
  igst: yup.number(),
  cgst: yup.number(),
  materialGroup: yup.string(),
  productInfoArray: yup.array(),
  productCount: yup.number(),
  productWeight: yup.number(),
});
export type TProductFormData = yup.InferType<
  typeof productForm
>;
